module.exports = __webpack_public_path__ + "media/images/front/pc/routable/img01-1691724dbb60847deab4703d3bbaddb3.png";